import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=6721c9a0&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"
import style0 from "./SocialIcons.vue?vue&type=style&index=0&id=6721c9a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721c9a0",
  null
  
)

export default component.exports